<ng-container>
    <form *ngIf="hasDataMappingItems" [formGroup]="selectorForm" class="flex flex-col justify-start items-start">
        <div class="wrapper flex flex-row">
            <mat-form-field class="m-r-20 full-grow-no-shrink-no-basis" appearance="outline">
                <mat-label>Select Field Mapping</mat-label>
                <mat-select formControlName="selectedMapping"
                            value='Select Field Mapping'>
                    <mat-option [matTooltip]="dataMapping.name" *ngFor="let dataMapping of dataMappings"
                                [value]="dataMapping">{{dataMapping.name}}</mat-option>
                </mat-select>
                <mat-error *ngIf="selectorForm.get('selectedMapping').hasError('required')">
                    Please choose a field mapping
                </mat-error>
            </mat-form-field>
            <button class="w-n-78" (click)="showSelectedMapping()" *ngIf="hasDataMappingOption"
                    [disabled]="selectorForm.get('selectedMapping').invalid"
                    mat-button>
                Show
            </button>
        </div>
        <mat-form-field *ngIf="hasDataMappingOption" appearance="outline" class="w-p-100">
            <mat-label>{{optionItemPlaceholder ? optionItemPlaceholder : 'Field Mapping Actions'}}</mat-label>
            <mat-select formControlName="dataMappingOption"
                        value='Select Option'>
                <mat-option *ngFor="let dataMappingOption of dataMappingOptions"
                            [value]="dataMappingOption">{{dataMappingOption.text}}</mat-option>
            </mat-select>
            <mat-error *ngIf="selectorForm.get('selectedMapping').hasError('required')">
                Please choose a field mapping
            </mat-error>
        </mat-form-field>
        <mat-form-field
                *ngIf=" hasDataMappingOption && selectorForm.get('dataMappingOption').value.id === 'create-new-questionnaire'"
                appearance="outline" class="w-p-100">
            <mat-label>File Name</mat-label>
            <input formControlName="filename" matInput>
            <mat-error *ngIf="selectorForm.get('filename').hasError('required')" class="m-b-5">
                File name is required
            </mat-error>
        </mat-form-field>
        <div class="wrapper flex flex-row">
            <mat-form-field class="m-r-20 full-grow-no-shrink-no-basis" appearance="outline">
                <mat-label>Source File Path</mat-label>
                <input formControlName="sourceFilePath" matInput
                       placeholder="Select Source File Path"
                       type="text">
            </mat-form-field>
            <mat-error *ngIf="selectorForm.get('sourceFilePath').hasError('required')">
                Please choose a valid source file
            </mat-error>
            <button class="common-button" (click)="openFileSelector('Select Source File Path', false, false)"
                    mat-button>
                Browse
            </button>
        </div>
    </form>
    <div *ngIf="!hasDataMappingItems" class="note">
        <p>{{noDataMappingFoundMessage}}<span (click)="goToFieldMapping()"
                                              class="link-button">Go to Field Mapping</span>
        </p>
    </div>
</ng-container>

